import { render, staticRenderFns } from "./CheckBoxGroup.vue?vue&type=template&id=189eb280&scoped=true&"
import script from "./CheckBoxGroup.vue?vue&type=script&lang=js&"
export * from "./CheckBoxGroup.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxGroup.vue?vue&type=style&index=0&id=189eb280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189eb280",
  null
  
)

export default component.exports